.picker {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
}
.header {
  font-size: var(--tuna-typography-h4-fontSize);
  font-weight: 600;
}
.keyGrid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: var(--tuna-spacing-2);
}
